/** @jsxImportSource @emotion/react */
import { useSelector } from 'react-redux';
import { useTheme } from '@emotion/react';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Text from '@Text';
import { selectJourneyProgress } from '../../Helpers/clientApiJourneyPosition.helpers';
import useClientApiCopy from './copy/useClientApiCopy';
import makeJourneyProgressStyles from './makeJourneyProgressStyles';

/**
 * The post-submission journey's own progress bar, counted over the journey's
 * stages and separate from the form's page progress.
 */
const JourneyProgress = () => {
  const theme = useTheme();
  const classes = makeJourneyProgressStyles({ theme });
  const copy = useClientApiCopy();

  const currentIndex = useSelector(
    (store) => selectJourneyProgress(store)?.currentIndex
  );
  const total = useSelector((store) => selectJourneyProgress(store)?.total);

  if (currentIndex === undefined) return null;

  const stage = currentIndex + 1;
  const percentage = Math.round((stage / total) * 100);

  return (
    <Box css={classes.container} data-testid="journeyProgressBar">
      <Box css={classes.labelRow}>
        <Box css={classes.label}>
          <Text variant="text" dataTestId="journeyProgressLabel">
            {copy.progress.step.replace('{n}', stage).replace('{x}', total)}
          </Text>
        </Box>
        <Box css={classes.percentage}>
          <Text variant="text" dataTestId="journeyProgressPercentage">
            {`${percentage}%`}
          </Text>
        </Box>
      </Box>
      <LinearProgress
        variant="determinate"
        value={percentage}
        css={classes.bar}
      />
    </Box>
  );
};

export default JourneyProgress;
